<template>
    <div>
        <vs-dialog prevent-close v-model="active">
            <template #header>
                <h4 class="not-margin">
                    CURP
                </h4>
            </template>


            <div class="con-form">
                <div class="form-group">
                    <form autocomplete="off">
                        <label for="escuela"  class="labelInput">
                            Fecha de nacimiento
                        </label>
                        <vs-input
                            class="pt-0"
                            type="date"
                            v-model="fecha_nacimiento"
                        >
                            <template #message-danger v-if="errorFields.includes('fecha_nacimiento')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </div>
                <div class="form-group">
                    <form autocomplete="off">
                        <label for="curp">CURP</label>
                        <input style="text-transform:uppercase;" v-model="curp" type="text"  class="form-control" id="curp" placeholder="CURP">
                        <div style="color:red;" v-if="invalidoCurp">
                            <small>Formato de CURP invalido.</small>
                        </div>
                        <div style="color:red;" v-if="errorFields.includes('curp')">
                            <small>Requerido</small>
                        </div>
                    </form>
                </div>
            </div>

            <template #footer>
                <div class="footer-dialog d-flex">
                    <vs-button danger block @click="borrar()" style="width: 30%;">
                    Cancelar
                    </vs-button>
                    <vs-button success class="ml-auto" block @click="postAvanzarModal()" style="width: 30%;">
                    Aceptar
                    </vs-button>
                </div>
            </template>
        </vs-dialog>
        <curp-existente v-model="curpExistente" :existente="existente" :idPersona="(informacion && informacion.id)" @refreshProcess="getRefresh"></curp-existente>
    </div>
</template>

<script>
import landing from '../../../../../../api/requests/landing'
import CurpExistente from './curp_existente.vue'
export default {
    props:[
      'value',
      'correo',
      'informacion'
    ],
    data(){
        return{
            active: false,
            curp: '',
            fecha_nacimiento: '',
            invalidoCurp: false,
            errorFields:[],
            curpExistente: false,
            existente: []
        }
    },
    components: {
        CurpExistente
    },
    methods:{
        borrar(){
            this.fecha_nacimiento = ''
            this.active = false           
        },
        
        getCurp(){
            if(this.informacion){
                const paterno = this.informacion.apellido_paterno.substr(0,2)
                this.curp = paterno
                const materno = this.informacion.apellido_materno.substr(0,1)
                this.curp = paterno + materno
                const nombre = this.informacion.nombres.substr(0,1)
                this.curp = paterno + materno + nombre
                if(this.fecha_nacimiento){
                    const year = this.fecha_nacimiento.substr(2,2)
                    const mes = this.fecha_nacimiento.substr(5,2)
                    const dia = this.fecha_nacimiento.substr(8,2)
                    this.curp = paterno + materno + nombre + year + mes + dia
                }
            }

        },
        getvalidateCurp(){
            const curpExp = new RegExp('[A-Z]{4}[0-9]{6}[HM]{1}[A-Z]{2}[A-Z]{3}[0-9A-Z]{2}')
            this.validateCurp = curpExp.test(this.curp.toUpperCase());
            if(this.validateCurp == false){
                this.invalidoCurp = true
            }
            return this.validateCurp
        },
        getRefresh(){
            this.$emit('refreshProcess')
        },
        async postAvanzarModal(){
            this.errorFields = []
            if (!this.fecha_nacimiento) {
                this.errorFields.push('fecha_nacimiento')
            }else if (!this.errorFields.length){
            const curpValidar = this.getvalidateCurp()
                if(curpValidar){
                    const loading = this.$vs.loading()
                    try{
                        const formData = new FormData()
                        formData.append('curp', this.curp.toUpperCase())
                        formData.append('fecha_nacimiento', this.fecha_nacimiento)
                        const response = await landing.postAvanzarCurp(this.informacion.id, formData)
                        if(response.data.status_busqueda == 'CURP encontrado en otro alumno'){
                            this.existente = response.data
                            this.curpExistente =! this.curpExistente
                            this.active = false
                            loading.close()
                        }else{
                            this.active = false
                            loading.close()
                            this.$emit('refreshProcess')
                        }
                        this.active = false
                    }catch(error){
                        loading.close()
                        console.log(error)
                    }
                }
            }
        },
        sanityForm () {
            this.errorFields = []

            if (!this.asunto) {
                this.errorFields.push('asunto')
            }
            if (!this.errorFields.length){
                const params = {
                    asunto: this.asunto,
                    mensaje: this.mensaje,
                    prospecto_id: this.correo.prospecto_id,
                    status_id: this.correo.status_id
                }
                return params
            } else {
                return null
            }
        },
        async postEnviarCorreoProceso(){
            const info = this.sanityForm()
            if(info){
                try{
                    const payload = Object.assign(info)
                    const response = await landing.postEnviarCorreoProceso(payload)
                    this.borrar()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Exito',
                        text: `Se envio el correo correctamente.`
                    })
                }catch(error){
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Hubo un error',
                        text: `Favor de contactar al administrador.`
                    })
                }
            }
        }
    },
    watch: {
        value (val) {
            this.active = val
        },
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
    }
}
</script>